import { render, staticRenderFns } from "./mvPdfInfo.vue?vue&type=template&id=90dbf844&scoped=true"
import script from "./mvPdfInfo.vue?vue&type=script&lang=js"
export * from "./mvPdfInfo.vue?vue&type=script&lang=js"
import style0 from "./mvPdfInfo.vue?vue&type=style&index=0&id=90dbf844&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "90dbf844",
  null
  
)

export default component.exports